import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "indicator"]
  static values = {
    interval: { type: Number, default: 5000 },
    autoplay: { type: Boolean, default: true }
  }

  connect() {
    this.currentIndex = 0
    this.showSlide(this.currentIndex)

    if (this.autoplayValue) {
      this.startAutoplay()
    }
  }

  disconnect() {
    this.stopAutoplay()
  }

  startAutoplay() {
    this.autoplayTimer = setInterval(() => {
      this.next()
    }, this.intervalValue)
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer)
    }
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.slideTargets.length
    this.showSlide(this.currentIndex)
  }

  previous() {
    this.currentIndex = (this.currentIndex - 1 + this.slideTargets.length) % this.slideTargets.length
    this.showSlide(this.currentIndex)
  }

  goToSlide(event) {
    this.stopAutoplay()
    this.currentIndex = parseInt(event.currentTarget.dataset.index)
    this.showSlide(this.currentIndex)

    if (this.autoplayValue) {
      this.startAutoplay()
    }
  }

  showSlide(index) {
    this.slideTargets.forEach((slide, i) => {
      if (i === index) {
        slide.classList.add("active")
      } else {
        slide.classList.remove("active")
      }
    })

    if (this.hasIndicatorTarget) {
      this.indicatorTargets.forEach((indicator, i) => {
        if (i === index) {
          indicator.classList.add("active")
        } else {
          indicator.classList.remove("active")
        }
      })
    }
  }

  pauseOnHover() {
    this.stopAutoplay()
  }

  resumeOnLeave() {
    if (this.autoplayValue) {
      this.startAutoplay()
    }
  }
}
